// Ce que le serveur répond aux écritures de lots, mis en phrases (lot 057).
// Aucun code à l'écran : les refus portent la phrase en français du serveur.

import { accorde } from './formats';

const plaqueDe = (lignesParId, id, repli = null) => lignesParId?.[id]?.tractor_plate || repli;

/** `{ id: ligne }` à partir d'une liste de lignes. */
export const indexerLignes = (lignes) =>
  Object.fromEntries((lignes || []).filter((ligne) => ligne?.id).map((ligne) => [ligne.id, ligne]));

const phrase = accorde;

/**
 * Confirmation groupée : `{ created, rejected, unchanged }`.
 * Rend le titre, la gravité et les refus `[{ plaque, message }]`.
 */
export const resumerConfirmation = (resultat) => {
  const confirmes = (resultat?.created || []).length;
  const deja = (resultat?.unchanged || []).length;
  const refuses = resultat?.rejected || [];
  const morceaux = [];
  if (confirmes > 0) morceaux.push(phrase(confirmes, 'camion confirmé', 'camions confirmés'));
  if (deja > 0) morceaux.push(phrase(deja, 'déjà confirmé', 'déjà confirmés'));
  if (refuses.length > 0) morceaux.push(phrase(refuses.length, 'refusé', 'refusés'));
  return {
    titre: morceaux.length > 0 ? morceaux.join(' · ') : 'Rien à confirmer',
    gravite: refuses.length > 0 ? (confirmes > 0 ? 'partiel' : 'echec') : 'succes',
    refus: refuses.map((refus) => ({
      plaque: refus.tractor_plate || null,
      message: refus.message || 'Ce camion n’a pas pu être confirmé.',
    })),
  };
};

/**
 * « Départ retour » / « Rendu » : `{ changed, unchanged, refused }`.
 * `lignesParId` retrouve la plaque des camions refusés.
 */
export const resumerRetour = (resultat, lignesParId) => {
  const faits = (resultat?.changed || []).length;
  const deja = (resultat?.unchanged || []).length;
  const refuses = resultat?.refused || [];
  const morceaux = [];
  if (faits > 0) morceaux.push(phrase(faits, 'camion mis à jour', 'camions mis à jour'));
  if (deja > 0) morceaux.push(phrase(deja, 'déjà à jour', 'déjà à jour'));
  if (refuses.length > 0) morceaux.push(phrase(refuses.length, 'refusé', 'refusés'));
  return {
    titre: morceaux.length > 0 ? morceaux.join(' · ') : 'Rien à changer',
    gravite: refuses.length > 0 ? (faits > 0 ? 'partiel' : 'echec') : 'succes',
    refus: refuses.map((refus) => ({
      plaque: plaqueDe(lignesParId, refus.line_id),
      message: refus.reason || 'Ce camion n’a pas pu être mis à jour.',
    })),
  };
};
